import React, { useEffect, useContext, useRef, useMemo } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import sixDotIcon from "../../images/6doticon.svg";
import warningBlue from "../../images/warning-red-icon.svg";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import AssignsymbolPopup from "../AssignSymbols/AssignsymbolPopup";
import CustomModal from "../CustomModal";
import AccordionClaim from "../AssignSymbols/AccordionClaim";
import {
  getAllScripts,
  updatSlideData,
  getVeevaLinkedModulesListByid,
  updateModuleCardsinEditor,
} from "../../services/apis";
import CircularProgressBar from "../../utils/CircularProgressBar";
import ValueContext from "../../utils/contextAPI/contextAPI";
import { styled } from "@mui/material/styles";
import DraggableItem from "./DraggableItem";
import {
  isMatchVariantGroupUsedOnEditor,
  matchVariantGroupHasContent,
  relatedItemsSubpanelHasUnusedOnEditor,
  isSlicePlacedOnEditor,
  isContentIdUsedOnEditorOrDeck,
  buildSharedRelatedSymbolLookup,
  normRelatedId,
  cssQuotedAttr,
  normalizeModuleContentKey,
} from "../../utils/editorUtils/claimEditorUsage";

const AssociatedCard = ({
  claim,
  reusableText,
  component,
  sendAtomDetails2Canvas,
  index,
  setExpandModule,
  expandModule,
  modulesArray,
  customDrag,
  editor,
  moduleClaimsData,
  modulesList,
  usedClaims,
  canvasGen,
  assignedSymbols,
  setAssignedSymbols,
}) => {
  const [expand, setExpand] = useState(false);
  const [testw, setTest] = useState(true);
  const [expandRelatedClaim, setExpandRelatedClaim] = useState(false);
  const [expandCompReusableText, setExpandCompReusableText] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [idlist, setIdList] = useState([]);
  const { pageId } = useParams();
  const appData = useContext(ValueContext);

  const relatedSymbolLookup = useMemo(
    () => buildSharedRelatedSymbolLookup(assignedSymbols),
    [assignedSymbols],
  );

  //editor.on("load", )

  //  editor.on('canvas:drop', (cmp,block)=>{

  //  // debugger;
  //   setTest(true)
  //     // window.localStorage.setItem("eledrop", true);
  //   })
  // const test2 = () =>{
  //   //debugger
  //   return true
  // }
  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.white,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }));

  const markMatchGroupUsed = (data, id) => {
    const clickedItem = data.find((item) => item.id === id);
    if (!clickedItem) return data;

    // Only apply this logic if clicked attribute is matchText or matchTextVariant
    if (
      clickedItem.attribute !== "matchText" &&
      clickedItem.attribute !== "matchTextVariant"
    ) {
      return data.map((item) =>
        item.id === id ? { ...item, used: true } : item,
      );
    }

    const { elementId } = clickedItem;

    return data.map((item) => {
      if (
        item.moduleId === clickedItem.moduleId &&
        item.elementId === elementId &&
        (item.attribute === "matchText" ||
          item.attribute === "matchTextVariant")
      ) {
        return { ...item, used: true };
      }

      return item.id === id ? { ...item, used: true } : item;
    });
  };

  const MATCH_ATTRIBUTES = new Set(["matchText", "matchTextVariant"]);

  const updateUsedState = (data, id, action) => {
    const clicked = data.find((item) => item.id === id);
    if (!clicked) return data;

    const targetElementId = clicked.elementId;
    const targetNorm = normalizeModuleContentKey(clicked.content);

    return data.map((item) => {
      let shouldBeUsed = item.used;
      let newCount = item.count || 0;
      // 1️⃣ Direct click
      if (item.id === id) {
        shouldBeUsed = action === "add" ? true : false;
        // newCount = action === "add" ? newCount + 1 : Math.max(0, newCount - 1);
      }

      // 2️⃣ MatchText / Variant pairing inside same elementId
      if (
        MATCH_ATTRIBUTES.has(clicked.attribute) &&
        item.moduleId === clicked.moduleId &&
        item.elementId === targetElementId &&
        MATCH_ATTRIBUTES.has(item.attribute)
      ) {
        shouldBeUsed = action === "add" ? true : false;
      }

      // 3️⃣ Same module + same normalized content (parent vs related, footnote vs match, etc.)
      if (
        targetNorm &&
        item.moduleId === clicked.moduleId &&
        normalizeModuleContentKey(item.content) === targetNorm
      ) {
        const clickedMatch = MATCH_ATTRIBUTES.has(clicked.attribute);
        const itemMatch = MATCH_ATTRIBUTES.has(item.attribute);
        if (clickedMatch && itemMatch && item.elementId !== targetElementId) {
          /* two different slices with coincidentally identical match copy — do not link */
        } else {
          shouldBeUsed = action === "add" ? true : false;
        }
      }

      return { ...item, used: shouldBeUsed, count: newCount };
    });
  };

  function getContentText(comp) {
  let current = comp;

  // Step 1: գտ parent with data-content-id
  while (current) {
    const attrs = current.getAttributes();
    if (attrs['data-content-id']) {
      break;
    }
    current = current.parent();
  }

  if (!current) return null;

  // Step 2: clone HTML and remove unwanted tags like <sup>
  const el = document.createElement('div');
  el.innerHTML = current.toHTML();

  // remove all <sup> (or any unwanted tags)
  el.querySelectorAll('sup').forEach(s => s.remove());

  // Step 3: return clean text
  return el.textContent.trim();
}

  editor?.on("component:add", function (elem) {
    setClaimsOnEditorAsset(!claimsOnEditorAsset);
    console.log("app data", appData.deckId);
    const allComps = editor?.getWrapper();
    const currentModules = appData?.deckId?.selected_module_data || [];
    //filter the consolidate data
    const comp = allComps?.find(
      `[data-content-id=${elem.getAttributes()["data-content-id"]}]`,
    );
    if (elem.getAttributes()['src']) {
       setIdList([elem.getAttributes()['src']]);
    } else {
       setIdList([elem.attributes.content]);
       const text = getContentText(elem);

  if (text) {
    console.log(text);
    setIdList([text]);
  }
       /* const text = elem.get('components').models.map(m => m.get('content')).join('');
       setIdList([text]); */
    }
   

    const parent = elem.parent();

    if (parent?.getAttributes()?.["data-content-id"]) return;

    const id = elem.getAttributes()?.["data-content-id"];
    if (!id) return;

    appData.setDeckId((prev) => {
      const updated = updateUsedState(
        prev.selected_module_data ?? [],
        id,
        "add",
      );

      return {
        ...prev,
        selected_module_data: updated,
        lastAction: "add", // 👈 mark action
      };
    });
    // return if its not parent claim
    if (!elem.getAttributes()["parent-claim"]) return;

    //if it is parent claim
    if (!editor) return false;

    if (!allComps || typeof allComps.find !== "function") {
      return false;
    }
    try {
      if (allComps) {
        // Keep editable: true so toolbar appears, but prevent content editing via contenteditable and event handlers
        elem.set({
          editable: true, // Keep editable so inline toolbar can appear
          selectable: true, // Allows selection for styling via inline toolbar
        });
        
        // Note: Event handlers for preventing text input will be set up in rte:enable handler
        // This allows the toolbar to work properly while still preventing content editing
        
        const claimParentOnEditor = allComps?.find(
          cssQuotedAttr("parent-claim", claim.claimName),
        );
        let symbolElements = "";
        for (var i = 0; i < claimParentOnEditor.length; i++) {
          symbolElements = claimParentOnEditor[i]?.find("sup");
        }
        let claimId = "";
        if (symbolElements.length > 0) {

            

          symbolElements.forEach((symbolElement) => {
            if (elem.getAttributes()["parent-claim"] === claim.claimName){
              const symbolId = symbolElement.getAttributes()["claim-id"];
            const claimRelatedOnEditor = allComps?.find(
              cssQuotedAttr("related-claim", symbolId),
            );
              if(claimRelatedOnEditor.length > 0){
                symbolElement.setStyle(
                  { display: "inline-block !important" },
                  { avoidStore: false },
                );
              } else {
                symbolElement.setStyle(
                  { display: "none" },
                  { avoidStore: false },
                );
              }}
            symbolElement.addAttributes({ contenteditable: "false" });
            symbolElement.set({
              editable: false,
              selectable: false,
              draggable: false,
              droppable: false,
              removable: false,
              copyable: false,
              removable: false,
            });
          });
        }
      }
    } catch (err) {
      return false;
    }
  }); // added to re-render the whole lfs on adding/removing text from editor

  function updateDBDeckContent(deckId, payload) {
    const payloadInput = {
      selected_module_data: payload,
    };
    return new Promise((resolve, reject) => {
      updateModuleCardsinEditor(deckId, payloadInput, (response, err) => {
        if (err) {
          reject(err);
        } else {
          resolve(response?.data?.response?.selected_module_data || []);
        }
      });
    });
  }

  let isRemoving = false;
  editor.on("component:remove", (component) => {
    console.log(
      component.getAttributes()["data-content-id"],
      "====================",
    );
    const currentModules = appData?.deckId?.selected_module_data ?? [];

    // ✅ Remove parent + children in one go
    let updatedModules = currentModules;
    const id = component.getAttributes()["data-content-id"];

    updatedModules = updateUsedState(updatedModules, id, "remove");
    // ✅ Update state ONCE
    appData.setDeckId((prev) => {
      const updated = updateUsedState(
        prev.selected_module_data ?? [],
        id,
        "remove",
      );
     
      //updateDBDeckContent(prev._id, updatedModules);

      return {
        ...prev,
        selected_module_data: updated,
        lastAction: "remove",
      };
    });

    setClaimsOnEditorAsset(!claimsOnEditorAsset);
    if (!component.getAttributes()["parent-claim"]) return;

    const parent = component.parent();
    if (!parent || parent.is("wrapper")) return;

    //parent.remove();
    setExpandRelatedClaim(!expandRelatedClaim);
  });

  editor.on("component:remove:after", (component) => {
    const id = component.getAttributes()["data-content-id"];
    if (!id) return; // ❌ Ignore elements without content-id

    // 🔥 Check if its parent also has content-id
    const parent = component.parent();
    const parentHasContentId =
      parent && parent.getAttributes()["data-content-id"];

    if (parentHasContentId) return; // ❌ It's a child, ignore

    // ✅ This is the top-level removed component
    const latestModules = appData?.deckId?.selected_module_data ?? [];

    // updateDBDeckContent(appData?.deckId?._id, latestModules);
  });

  //remove all other related claims content along with parent
  editor?.on("component:remove:before", function (elem) {
    isRemoving = true;
    //filter the consolidate data
    if (elem.getAttributes()["data-content-id"]) {
      const parentId = elem.getAttributes()["data-content-id"];
      const parentClaim = elem.getAttributes()["parent-claim"];
    }
    setClaimsOnEditorAsset(!claimsOnEditorAsset);
    //if (!elem.getAttributes()["related-claim"]) return;
    // setIdList([elem.getAttributes()["data-content-id"]]);
    let text = '';
    console.log('remove lhs', elem)
    if (elem.getAttributes()['src']) {
      text = elem.getAttributes()['src']
    } else {
       text = elem.get('components').models.map(m => m.get('content')).join('');
    }
    
    console.log('remove lhs', elem.get('components').models.map(m => m.get('content')).join(''))
    //setIdList([elem.attributes.content]);
    setIdList([text]);
    const allComps = editor?.getWrapper();
    if (!allComps || typeof allComps.find !== "function") {
      return false;
    }
    const claimParentOnEditor = allComps?.find(
      cssQuotedAttr(
        "parent-claim",
        elem.getAttributes()["parent-claim"] || claim?.claimName,
      ),
    );
    if (elem.getAttributes()["parent-claim"]) {
      setPreviewLoading(true);
      let claimRelatedOnEditor = "";
      let symbolElements = "";
      if (elem.getAttributes()["parent-claim"].includes("COMP-")) {
        claimRelatedOnEditor = allComps.find(
          cssQuotedAttr(
            "related-claim-comp",
            elem.getAttributes()["parent-claim"],
          ),
        );
        if (claimRelatedOnEditor.length > 0) {
          for (var i = 0; i < claimRelatedOnEditor.length; i++) {
            claimRelatedOnEditor[i].remove();
          }
        }
      }
      for (var i = 0; i < claimParentOnEditor.length; i++) {
        symbolElements = claimParentOnEditor[i]?.find("sup");
      }

      if (symbolElements.length > 0) {
        symbolElements.forEach((symbolElement) => {
          claimRelatedOnEditor = allComps?.find(
            cssQuotedAttr(
              "related-claim",
              symbolElement.getAttributes()["claim-id"],
            ),
          );
          if (claimRelatedOnEditor.length > 0) {
            for (var i = 0; i < claimRelatedOnEditor.length; i++) {
              claimRelatedOnEditor[i].remove();
            }
          }
        });
      }
      setPreviewLoading(false);
    }
  });
  const [claimsOnEditorAsset, setClaimsOnEditorAsset] = useState(false);
  void canvasGen;

  /** True = content already on slide → gray out / block drag (id on canvas or same copy elsewhere in module). */
  const isDraggable = (claimContent, componentId, moduleId) =>
    isSlicePlacedOnEditor(
      editor,
      appData?.deckId?.selected_module_data,
      moduleId,
      componentId,
      claimContent,
    );

  const isImageAlreadyUsed = (contentId) =>
    isContentIdUsedOnEditorOrDeck(
      editor,
      appData?.deckId?.selected_module_data,
      contentId,
    );
  /* const isDraggable = (claimContent) => {
    if (!claimContent) return false;

    const normalized = claimContent.trim().replace(/\s+/g, "").toLowerCase();
    const modules = appData?.deckId?.selected_module_data ?? [];

    // Block drag if any content with same text is already used
    return modules.some(
      (item) =>
        (item.content || "").trim().replace(/\s+/g, "").toLowerCase() ===
          normalized && item.used === true,
    );
  }; */

  const isReusableTextUsed = (contentId) => {
    const modules = appData?.deckId?.selected_module_data ?? [];
    const found = modules.find((item) => item.id === contentId);
    return found?.used === true;
  };

  const parentClaimAdded = (claimId) => {
    if (!editor) return false;
    const allComps = editor?.getWrapper();
    if (!allComps || typeof allComps.find !== "function") {
      return false;
    }
    try {
      if (allComps && claimId) {
        const claimParentOnEditor = allComps?.find(
          cssQuotedAttr("parent-claim", claimId),
        );
        return claimParentOnEditor?.length > 0 ? true : false;
      }
    } catch (err) {
      console.error("Error in wrapper.find:", err);
      return false;
    }
  };

  const moduleDamForClaim = moduleClaimsData?.moduleDamName;
  const mainClaimMatchGroupUsed = !!(
    claim &&
    editor &&
    isMatchVariantGroupUsedOnEditor(
      editor,
      moduleDamForClaim,
      claim.claimName,
      null,
      claim,
    )
  );
  const mainClaimMatchGroupLocked =
    !!claim &&
    (parentClaimAdded(claim.claimName) || mainClaimMatchGroupUsed);
  const showClaimRelatedSubpanel =
    !claim?.relatedClaims?.length ||
    !usedClaims ||
    relatedItemsSubpanelHasUnusedOnEditor(
      editor,
      moduleDamForClaim,
      claim.claimName,
      claim.relatedClaims,
      appData?.deckId?.selected_module_data,
    );
  const showCompRelatedClaimsSubpanel =
    !component?.relatedClaims?.length ||
    !usedClaims ||
    relatedItemsSubpanelHasUnusedOnEditor(
      editor,
      moduleClaimsData?.moduleDamName,
      component?.componentDocNumber,
      component?.relatedClaims,
      appData?.deckId?.selected_module_data,
    );
  const showCompRelatedReusableSubpanel =
    !component?.relatedReusableTexts?.length ||
    !usedClaims ||
    relatedItemsSubpanelHasUnusedOnEditor(
      editor,
      moduleClaimsData?.moduleDamName,
      component?.componentDocNumber,
      component?.relatedReusableTexts,
      appData?.deckId?.selected_module_data,
    );

  const grayout = (claimMatchText) => {
    const decodedString = new DOMParser().parseFromString(
      editor?.getHtml(),
      "text/html",
    ).documentElement.textContent;
    return decodedString
      .replace(/\s+/g, "")
      .includes(claimMatchText?.replace(/\s+/g, ""));
  };

  const getAssignedSymbolsOnLoad = () => {
    if (!modulesList?.length) return;
    setPreviewLoading(true);
    getAllScripts(pageId, (response, err, errorCode) => {
      if (err) {
        setPreviewLoading(false);
        // setIsloading(false);
      } else {
        // setIsloading(false);
        const selectedRelatedClaims = response?.data?.relatedClaimsData;
        const IdsModule = new Set(modulesList.map((item) => item.module_name));
        const result = modulesList.reduce((acc, item) => {
          const rules = item.content_module_response?.moduleBusinessRules || [];
          return acc.concat(rules.map((r) => r.targetModuleDamName));
        }, []);
        const finalResult = [...new Set([...IdsModule, ...result])];
        const filterClaims = selectedRelatedClaims.filter((item) =>
          finalResult.includes(item.moduleId),
        );
        const payLoad = {
          relatedClaimsData: filterClaims,
        };

        updatSlideData(pageId, payLoad, (response, err, errorCode) => {
          if (err) {
            // setIsloading(false);
          } else {
            // setIsloading(false);

            setAssignedSymbols(filterClaims);
          }
        });
        setPreviewLoading(false);
      }
    });
  };

  const dragMatch = (e, from) => {
    if (from === "footnotes") {
      e.dataTransfer.setData("text", e.target.innerText);
    } else if (from === "ref") {
      const el = e.currentTarget;
      const clone = el.cloneNode(true);
      clone.querySelector("span")?.remove();

      //const el = e.target.innerHTML;
      const lastEl = clone.lastChild;
      lastEl?.querySelector("span")?.remove();
      e.dataTransfer.setData("text/html", lastEl.innerHTML); //e.target.lastChild.innerHTML
      //e.dataTransfer.setData("text/plain", clone.textContent.trim());
    } else {
      const el = e.target.innerHTML;
      e.dataTransfer.setData("text/html", e.target.lastChild.innerHTML);
    }
    e.dataTransfer.setDragImage(e.nativeEvent.srcElement, 0, 0);
  };

  /** Deck-wide count PATCH must run once: every mounted AssociatedCard shared the same effect otherwise N cards → N timers. */
  const debounceRef = useRef(null);
  useEffect(() => {
    if (index !== 0) return;
    if (appData?.deckId?.lastAction !== "add" && appData?.deckId?.lastAction !== "remove") return;
    if (!idlist?.length) return;
    clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      const contentKey = idlist[0];
      let payloadForPatch = null;
      let deckIdForPatch = null;

      appData.setDeckId((prev) => {
        const action = prev.lastAction;
        if (contentKey == null || (action !== "add" && action !== "remove")) {
          return { ...prev, lastAction: null };
        }
        const delta = action === "add" ? 1 : -1;
        const modules = prev.selected_module_data ?? [];
        const newData = modules.map((item) => {
          if (item.content !== contentKey) return item;
          return {
            ...item,
            count: Math.max(0, (item.count || 0) + delta),
          };
        });
        payloadForPatch = newData;
        deckIdForPatch = prev._id;
        return {
          ...prev,
          selected_module_data: newData,
          lastAction: null,
        };
      });

      if (payloadForPatch != null && deckIdForPatch != null) {
        updateDBDeckContent(deckIdForPatch, payloadForPatch);
      }
      setIdList([]);
    }, 300);
  }, [appData?.deckId?.lastAction, idlist, index]);
  /* const debounceRef = useRef(null);

useEffect(() => {
  const lastAction = appData?.deckId?.lastAction;
  if (!lastAction || (lastAction !== "add" && lastAction !== "remove")) return;
  if (!idlist.length) return;

  clearTimeout(debounceRef.current);

  debounceRef.current = setTimeout(() => {
    const newData = appData.deckId.selected_module_data.map((item) =>
      item.content === idlist[0]
        ? {
            ...item,
            count: item.count + (lastAction === "add" ? 1 : -1),
          }
        : item
    );

    console.log("After update", newData);

    updateDBDeckContent(appData.deckId._id, newData);

    // reset action and idlist
    appData.setDeckId((prev) => ({ ...prev, lastAction: null }));
    setIdList([]);
  }, 300);
}, [appData?.deckId?.lastAction, idlist, appData?.deckId?.selected_module_data]); */
  return (
    <>
      {previewLoading && (
        <CircularProgressBar
          isloading={previewLoading}
          setIsloading={setPreviewLoading}
        />
      )}
      <div className="associated-modules" style={{ cursor: "pointer" }}>
        <div
          style={{ display: "flex", alignItems: "center" }}
          onClick={() => {
            const expandModuleArr = [...expandModule];
            expandModuleArr[index] = !expand;
            setExpandModule(expandModuleArr);
            setExpand(!expand);
            getAssignedSymbolsOnLoad();
          }}
        >
          <div
            className="expand-module"
            style={{
              backgroundColor: expand ? "#F0F5F8" : "",
              color: expand ? "#203662" : "",
              fontSize: expand ? "30px" : "20px",
              fontWeight: expand ? "100" : "",
            }}
            onClick={() => {
              setExpand(!expand);
              setExpandRelatedClaim(false);
            }}
          >
            {" "}
            {expand ? (
              <p className="minusIcon22">-</p>
            ) : (
              <p className="plusIcon22">+</p>
            )}{" "}
          </div>
          {claim && (
            <div className="boldText" style={{ marginLeft: "4px" }}>
              {claim.claimName}
            </div>
          )}
          {reusableText && (
            <div className="boldText" style={{ marginLeft: "4px" }}>
              {reusableText.reusableTextName}
            </div>
          )}
          {component && (
            <div className="boldText" style={{ marginLeft: "4px" }}>
              {component.componentDocNumber}
            </div>
          )}
          {claim && (
            <div
              className="parentModulebox"
              style={{
                backgroundColor: claim.mustUse === true ? "#E32B35" : "#378A05",
                marginLeft: "10px",
              }}
            ></div>
          )}
          {/* <div onClick={()=>setOpenAssignPopup(true)}>Assign Symbol</div>      */}
          {reusableText && (
            <div
              className="parentModulebox"
              style={{
                backgroundColor:
                  reusableText.mustUse === true ? "#E32B35" : "#378A05",
                marginLeft: "10px",
              }}
            ></div>
          )}
          {component && (
            <div
              className="parentModulebox"
              style={{
                backgroundColor:
                  component.mustUse === true ? "#E32B35" : "#378A05",
                marginLeft: "10px",
              }}
            ></div>
          )}
          {/* <img src={warningBlue} style={{ marginLeft: "10px" }} /> */}
        </div>
        {!expand && index !== modulesArray.length - 1 && (
          <div className="horizonatlLine"></div>
        )}
      </div>
      {expand && (
        <div classname="text-container pb-2">
          {claim && (
            <>
              {" "}
              {matchVariantGroupHasContent(claim) &&
                (!usedClaims || !mainClaimMatchGroupUsed) && (
                  <>
                    {claim.matchText && (
                      <>
                    <div className="matchText showContent_OnEditor">
                      Match Text{" "}
                    </div>
                    <div
                      className={` draggableText
                  ${
                    !usedClaims && !mainClaimMatchGroupLocked
                      ? "d-flex"
                      : usedClaims
                        ? "d-flex"
                        : ""
                  }
                  ${!usedClaims && mainClaimMatchGroupLocked ? "grayOut" : ""} 
                  showContent_OnEditor
                `}
                      draggable={
                        usedClaims
                          ? true
                          : !mainClaimMatchGroupLocked
                      }
                      onDragStart={(e) =>
                        dragMatch(
                          e,
                          `${moduleClaimsData?.moduleDamName}-${claim.claimName}-matchText`,
                        )
                      }
                      onDragEnd={(e) => {
                        setClaimsOnEditorAsset(!claimsOnEditorAsset);
                      }}
                      onDragOver={(e) => e.preventDefault()}
                    >
                      <img
                        src={sixDotIcon}
                        alt=""
                        className="img-fluid sixdotIcon"
                      />
                      <div className="textvariant">
                        <div
                          module-claim={moduleClaimsData?.moduleDamName}
                          parent-claim={claim.claimName}
                          className="parent-claim"
                          data-content-id={`${moduleClaimsData?.moduleDamName}-${claim.claimName}-matchText`}
                        >
                          {claim.matchText}
                          {(claim.relatedClaims || []).map((rel) => {
                            const rid = normRelatedId(
                              rel.claimName || rel.reusableTextName || "",
                            );
                            if (!rid) return null;
                            const mod = normRelatedId(
                              moduleClaimsData.moduleDamName,
                            );
                            const sym = relatedSymbolLookup.get(`${mod}|${rid}`);
                            if (sym == null || sym === "") return null;
                            return (
                              <sup
                                key={`lhs-rc-${rid}`}
                                className="hide-Lhs-sup"
                                claim-id={rid}
                                contentEditable={false}
                                style={{ userSelect: "none" }}
                              >
                                {sym}
                              </sup>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                      </>
                    )}
                {claim.matchTextVariants?.map((item, index) => {
                  const variantContentId = `${moduleClaimsData?.moduleDamName}-${claim.claimName}-variant-${item.id}`;
                  return (
                    <React.Fragment key={item.id ?? index}>
                      <div className="matchText showContent_OnEditor">{`Match Text Variant ${index + 1}`}</div>
                      <div
                        className={` draggableText
                          ${
                            !usedClaims && !mainClaimMatchGroupLocked
                              ? "d-flex"
                              : usedClaims
                                ? "d-flex"
                                : ""
                          }
                          ${!usedClaims && mainClaimMatchGroupLocked ? "grayOut" : ""}
                          showContent_OnEditor
                          `}
                        draggable={
                          usedClaims
                            ? true
                            : !mainClaimMatchGroupLocked
                        }
                        onDragStart={(e) =>
                          dragMatch(
                            e,
                            variantContentId,
                          )
                        }
                        //onDragStart={(e) => dragMatch(e)}
                        onDragEnd={(e) => {
                          setClaimsOnEditorAsset(!claimsOnEditorAsset);
                        }}
                        onDragOver={(e) => e.preventDefault()}
                      >
                        <img
                          src={sixDotIcon}
                          alt=""
                          className="img-fluid sixdotIcon"
                        />
                        <div className="textvariant">
                          {item.matchText && (
                            <div
                              module-claim={moduleClaimsData?.moduleDamName}
                              parent-claim={claim.claimName}
                              className="parent-claim"
                              data-content-id={variantContentId}
                            >
                              {item.matchText}
                              {(claim.relatedClaims || []).map((rel) => {
                                const rid = normRelatedId(
                                  rel.claimName || rel.reusableTextName || "",
                                );
                                if (!rid) return null;
                                const mod = normRelatedId(
                                  moduleClaimsData.moduleDamName,
                                );
                                const sym = relatedSymbolLookup.get(`${mod}|${rid}`);
                                if (sym == null || sym === "") return null;
                                return (
                                  <sup
                                    key={`lhs-rc-v-${item.id ?? index}-${rid}`}
                                    className="hide-Lhs-sup"
                                    claim-id={rid}
                                    contentEditable={false}
                                    style={{ userSelect: "none" }}
                                  >
                                    {sym}
                                  </sup>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
                  </>
                )}
              {claim.footnotes?.length > 0 &&
                (!usedClaims ||
                  !isDraggable(
                    claim.footnotes,
                    `${claim.claimName}-footnote`,
                    moduleClaimsData?.moduleDamName,
                  )) && (
                  <div className="matchText1 showContent_OnEditor">
                    Footnotes{" "}
                  </div>
                )}
              {claim?.footnotes?.length > 0 && (
                <DraggableItem
                  key={claim.footnotes}
                  content={claim.footnotes}
                  moduleId={moduleClaimsData?.moduleDamName}
                  componentId={`${claim.claimName}-footnote`}
                  isUsed={isDraggable(
                    claim.footnotes,
                    `${claim.claimName}-footnote`,
                    moduleClaimsData?.moduleDamName,
                  )} // content-based check
                  hideIfUsed={usedClaims}
                  isPlacedOnEditor={isDraggable(
                    claim.footnotes,
                    `${claim.claimName}-footnote`,
                    moduleClaimsData?.moduleDamName,
                  )}
                  dragMatch={dragMatch}
                  onDragEndUpdate={() =>
                    setClaimsOnEditorAsset(!claimsOnEditorAsset)
                  }
                  sixDotIcon={null} // optional, no icon for references
                  type="default"
                />
              )}
              {claim.abbreviation?.length > 0 &&
                (!usedClaims ||
                  claim.abbreviation?.split(";").some((raw, abbrIdx) => {
                    if (!raw?.trim()) return false;
                    return !isDraggable(
                      raw.trim(),
                      `${claim.claimName}-abbreviation-${abbrIdx + 1}`,
                      moduleClaimsData?.moduleDamName,
                    );
                  })) && (
                  <div className="matchText1">Abbreviations</div>
                )}
              {claim.abbreviation?.split(";").length > 0 &&
                claim.abbreviation?.split(";").map((item, index) => {
                  const value = item.trim();
                  if (!value) return; // skip empty values

                  return (
                    <>
                      <DraggableItem
                        key={item}
                        content={item}
                        moduleId={moduleClaimsData?.moduleDamName}
                        componentId={`${claim.claimName}-abbreviation-${
                          index + 1
                        }`}
                        isUsed={isDraggable(
                          item,
                          `${claim.claimName}-abbreviation-${index + 1}`,
                          moduleClaimsData?.moduleDamName,
                        )} // content-based check
                        hideIfUsed={usedClaims}
                        isPlacedOnEditor={isDraggable(
                          item,
                          `${claim.claimName}-abbreviation-${index + 1}`,
                          moduleClaimsData?.moduleDamName,
                        )}
                        dragMatch={dragMatch}
                        onDragEndUpdate={() =>
                          setClaimsOnEditorAsset(!claimsOnEditorAsset)
                        }
                        sixDotIcon={null} // optional, no icon for references
                        type={null}
                      />
                    </>
                  );
                })}
              {claim.references?.length > 0 &&
                (!usedClaims ||
                  claim.references.some(
                    (ref) =>
                      !isDraggable(
                        ref.documentName,
                        `${claim.claimName}-reference-${ref.id}`,
                        moduleClaimsData?.moduleDamName,
                      ),
                  )) && <div className="matchText1">References</div>}
              {claim.references?.map((item, index) => {
                return (
                  <>
                    <DraggableItem
                      index={index}
                      key={item.id}
                      content={item.documentName}
                      moduleId={moduleClaimsData?.moduleDamName}
                      componentId={`${claim.claimName}-reference-${item.id}`}
                      isUsed={isDraggable(
                        item.documentName,
                        `${claim.claimName}-reference-${item.id}`,
                        moduleClaimsData?.moduleDamName,
                      )} // content-based check
                      hideIfUsed={usedClaims}
                      isPlacedOnEditor={isDraggable(
                        item.documentName,
                        `${claim.claimName}-reference-${item.id}`,
                        moduleClaimsData?.moduleDamName,
                      )}
                      dragMatch={dragMatch}
                      onDragEndUpdate={() =>
                        setClaimsOnEditorAsset(!claimsOnEditorAsset)
                      }
                      sixDotIcon={null} // optional, no icon for references
                      type="ref"
                    />
                  </>
                );
              })}
              {claim.relatedClaims.length > 0 &&
                showClaimRelatedSubpanel && ( //needs to work
                <div
                  style={{
                    display: "flex",
                    cursor: "pointer",
                    // pointerEvents: `${parentClaimAdded(claim.claimName) ? 'auto' : 'none'}`,
                    userSelect: "none",
                  }}
                  onClick={() => {
                    setExpandRelatedClaim(!expandRelatedClaim);
                    !expandRelatedClaim && getAssignedSymbolsOnLoad();
                  }}
                >
                  {
                    <div
                      className="expand-module"
                      style={{
                        backgroundColor: expandRelatedClaim ? "#F0F5F8" : "",
                        color: expandRelatedClaim ? "#203662" : "",
                        fontSize: expandRelatedClaim ? "24px" : "18px",
                        fontWeight: expandRelatedClaim ? "100" : "",
                        cursor: "pointer",
                        marginRight: "6px",
                      }}
                    >
                      {" "}
                      {expandRelatedClaim ? (
                        <p className="minusIcon22">-</p>
                      ) : (
                        <p className="plusIcon22">+</p>
                      )}{" "}
                    </div>
                  }
                  <div className="related-claim-block">
                    {`Related Claims`}
                    <span
                      style={{
                        color: "#888",
                        fontSize: "10px",
                        fontWeight: "400",
                      }}
                    >
                      {" "}
                      {`(${claim.relatedClaims.length} items)`}{" "}
                    </span>
                  </div>
                  <div
                    className="info-icon-div"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {
                      <LightTooltip
                        className="mlrToolTip"
                        title="To use Related Claims, first drag and drop a Claim into the editor, then assign a claim symbol to the Related Claims"
                        arrow
                      >
                        <img
                          src={warningBlue}
                          style={{
                            marginLeft: "10px",
                            pointerEvents: `${
                              parentClaimAdded(claim.claimName)
                                ? "auto"
                                : "auto"
                            }`,
                          }}
                        />
                      </LightTooltip>
                    }
                  </div>
                </div>
              )}
              {assignedSymbols !== null &&
                expandRelatedClaim &&
                showClaimRelatedSubpanel && (
                <AccordionClaim
                  relatedClaims={claim.relatedClaims}
                  claim={claim}
                  customDrag={customDrag}
                  setClaimsOnEditorAsset={setClaimsOnEditorAsset}
                  editor={editor}
                  claimsOnEditorAsset={claimsOnEditorAsset}
                  moduleClaimsData={moduleClaimsData}
                  assignedSymbols={assignedSymbols}
                  setAssignedSymbols={setAssignedSymbols}
                  setPreviewLoading={setPreviewLoading}
                  previewLoading={previewLoading}
                  displayFor="claim"
                  mustUseFlag={claim.mustUse}
                  hideUsedOnLHS={usedClaims}
                />
                )}
              {index !== modulesArray.length - 1 && (
                <div className="horizonatlLine"></div>
              )}
            </>
          )}
          {reusableText && (
            <>
              {" "}
              {reusableText.matchText &&
                (!usedClaims ||
                  !isDraggable(
                    reusableText.matchText,
                    `${reusableText.reusableTextName}-matchText`,
                    moduleClaimsData.moduleDamName,
                  )) && <div className="matchText">Match Text</div>}
              {reusableText.matchText && (
                <DraggableItem
                  content={reusableText.matchText}
                  moduleId={moduleClaimsData.moduleDamName}
                  componentId={`${reusableText.reusableTextName}-matchText`}
                  isUsed={isDraggable(
                    reusableText.matchText,
                    `${reusableText.reusableTextName}-matchText`,
                    moduleClaimsData.moduleDamName,
                  )} // your content-based check
                  hideIfUsed={usedClaims}
                  isPlacedOnEditor={isDraggable(
                    reusableText.matchText,
                    `${reusableText.reusableTextName}-matchText`,
                    moduleClaimsData.moduleDamName,
                  )}
                  dragMatch={dragMatch}
                  onDragEndUpdate={() =>
                    setClaimsOnEditorAsset(!claimsOnEditorAsset)
                  }
                  sixDotIcon={sixDotIcon}
                  type="default"
                />
                /* <div
                  className={`draggableText ${
                    isDraggable(reusableText.matchText,
                      `${reusableText.reusableTextName}-matchText`,
                      moduleClaimsData?.moduleDamName
                    )
                      ? "grayOut"
                      : ""
                  } d-flex showContent_OnEditor`}
                  draggable={true} // always true
                  onDragStart={(e) => {
                    const contentId = `${moduleClaimsData?.moduleDamName}-${reusableText.reusableTextName}-matchText`;

                    // 1️⃣ Block drag if already used
                    if (isReusableTextUsed(contentId)) {
                      e.preventDefault();
                      return;
                    }

                    // 2️⃣ Immediately set dataTransfer to prevent 🚫
                    e.dataTransfer.setData("text/plain", contentId);
                    e.dataTransfer.effectAllowed = "move";

                    // 3️⃣ Optional: ghost image to avoid browser cursor flicker
                    const dragGhost = document.createElement("div");
                    dragGhost.style.width = "1px";
                    dragGhost.style.height = "1px";
                    dragGhost.style.position = "absolute";
                    dragGhost.style.top = "-1000px";
                    document.body.appendChild(dragGhost);
                    e.dataTransfer.setDragImage(dragGhost, 0, 0);
                    setTimeout(() => document.body.removeChild(dragGhost), 0);

                    // 4️⃣ Call your drag logic
                    dragMatch(e, contentId);
                  }}
                  onDragEnd={() => setClaimsOnEditorAsset(!claimsOnEditorAsset)}
                  onDragOver={(e) => e.preventDefault()}
                >
                  <img
                    src={sixDotIcon}
                    alt=""
                    className="img-fluid sixdotIcon"
                  />
                  <div className="textvariant">
                    <div
                      module-claim={moduleClaimsData?.moduleDamName}
                      className="parent-claim"
                      data-content-id={`${moduleClaimsData?.moduleDamName}-${reusableText.reusableTextName}-matchText`}
                    >
                      {reusableText.matchText}
                    </div>
                  </div>
                </div> */
              )}
              {reusableText.matchTextVariants.length > 0 && (
                reusableText.matchTextVariants.map((item, index) => {
                  return (
                    <>
                      <div className="matchText">Match Text Variant {index + 1}</div>
                      <DraggableItem
                        content={item.matchText}
                        moduleId={moduleClaimsData.moduleDamName}
                        componentId={`${reusableText.reusableTextName}-matchTextVariant-${index + 1}`}
                        isUsed={isDraggable(
                          item.matchText,
                          `${reusableText.reusableTextName}-matchTextVariant-${index + 1}`,
                          moduleClaimsData.moduleDamName,
                        )}
                        hideIfUsed={usedClaims}
                        isPlacedOnEditor={isDraggable(
                          item.matchText,
                          `${reusableText.reusableTextName}-matchTextVariant-${index + 1}`,
                          moduleClaimsData.moduleDamName,
                        )}
                        dragMatch={dragMatch}
                        onDragEndUpdate={() =>
                          setClaimsOnEditorAsset(!claimsOnEditorAsset)
                        }
                        sixDotIcon={sixDotIcon}
                        type="default"
                      />
                    </>
                  );
                })

              )}
              {index !== modulesArray.length - 1 && (
                <div className="horizonatlLine"></div>
              )}
            </>
          )}

          {component && (
            <>
              {(!usedClaims ||
                !isImageAlreadyUsed(
                  `${moduleClaimsData?.moduleDamName}-${component.componentDocNumber}-componentUrl`,
                )) && (
                <div className="matchText">
                  {component?.relatedClaims?.length > 0 ||
                  component?.relatedReusableTexts?.length > 0
                    ? "Data Graphic"
                    : "Image"}
                </div>
              )}
              {(!usedClaims ||
                !isImageAlreadyUsed(
                  `${moduleClaimsData?.moduleDamName}-${component.componentDocNumber}-componentUrl`,
                )) && (
                <div
                  className={`d-flex draggableText ${
                    isImageAlreadyUsed(
                      `${moduleClaimsData?.moduleDamName}-${component.componentDocNumber}-componentUrl`,
                    )
                      ? "grayOut"
                      : ""
                  }`}
                  style={{
                    pointerEvents: isImageAlreadyUsed(
                      `${moduleClaimsData?.moduleDamName}-${component.componentDocNumber}-componentUrl`,
                    )
                      ? "none"
                      : "auto",
                    cursor: isImageAlreadyUsed(
                      `${moduleClaimsData?.moduleDamName}-${component.componentDocNumber}-componentUrl`,
                    )
                      ? "not-allowed"
                      : "move",
                  }}
                  onDragStart={(e) => {
                    const contentId = `${moduleClaimsData?.moduleDamName}-${component.componentDocNumber}-componentUrl`;
                    if (isImageAlreadyUsed(contentId)) {
                      e.preventDefault();
                      e.stopPropagation();
                      return;
                    }
                    customDrag(e);
                  }}
                  onDragOver={(e) => e.preventDefault()}
                >
                  <img
                    src={sixDotIcon}
                    alt=""
                    className="img-fluid sixdotIcon"
                  />
                  <div className="textvariant drag-image">
                    <img
                      src={component?.componentUrl}
                      alt=""
                      className="img-fluid sixdotIcon"
                      module-claim={moduleClaimsData?.moduleDamName}
                      parent-claim={component.componentDocNumber}
                      data-content-id={`${moduleClaimsData?.moduleDamName}-${component.componentDocNumber}-componentUrl`}
                      draggable={
                        !isImageAlreadyUsed(
                          `${moduleClaimsData?.moduleDamName}-${component.componentDocNumber}-componentUrl`,
                        )
                      }
                      onDragStart={(event) => {
                        const contentId = `${moduleClaimsData?.moduleDamName}-${component.componentDocNumber}-componentUrl`;
                        if (isImageAlreadyUsed(contentId)) {
                          event.preventDefault();
                          event.stopPropagation();
                          return;
                        }
                        const dragData = {
                          componentUrl: component?.componentUrl,
                          dataContentId: contentId,
                          moduleClaim: moduleClaimsData?.moduleDamName,
                          parentClaim: component.componentDocNumber,
                        };
                        const data = JSON.stringify(dragData);
                        event.dataTransfer.setData("application/json", data);
                        event.dataTransfer.effectAllowed = "copy";
                      }}
                      style={{
                        cursor: isImageAlreadyUsed(
                          `${moduleClaimsData?.moduleDamName}-${component.componentDocNumber}-componentUrl`,
                        )
                          ? "not-allowed"
                          : "move",
                      }}
                    />
                  </div>
                </div>
              )}
              {component?.title &&
                (!usedClaims ||
                  !isDraggable(
                    component.title,
                    component.componentDocNumber + "-title",
                    moduleClaimsData.moduleDamName,
                  )) && (
                  <div className="matchText">Title</div>
                )}
              {component?.title && (
                <DraggableItem
                  content={component.title}
                  moduleId={moduleClaimsData.moduleDamName}
                  componentId={component.componentDocNumber + "-title"}
                  isUsed={isDraggable(
                    component.title,
                    component.componentDocNumber + "-title",
                    moduleClaimsData.moduleDamName,
                  )} // your content-based check
                  hideIfUsed={usedClaims}
                  isPlacedOnEditor={isDraggable(
                    component.title,
                    component.componentDocNumber + "-title",
                    moduleClaimsData.moduleDamName,
                  )}
                  dragMatch={dragMatch}
                  onDragEndUpdate={() =>
                    setClaimsOnEditorAsset(!claimsOnEditorAsset)
                  }
                  sixDotIcon={sixDotIcon}
                  type="default"
                />
              )}

              {component.relatedClaims.length > 0 &&
                showCompRelatedClaimsSubpanel && ( //needs to work
                <div
                  style={{
                    display: "flex",
                    cursor: "pointer",
                    // pointerEvents: `${parentClaimAdded(claim.claimName) ? 'auto' : 'none'}`,
                    userSelect: "none",
                  }}
                  onClick={() => {
                    setExpandRelatedClaim(!expandRelatedClaim);
                    !expandRelatedClaim && getAssignedSymbolsOnLoad();
                  }}
                >
                  {
                    <div
                      className="expand-module"
                      style={{
                        backgroundColor: expandRelatedClaim ? "#F0F5F8" : "",
                        color: expandRelatedClaim ? "#203662" : "",
                        fontSize: expandRelatedClaim ? "24px" : "18px",
                        fontWeight: expandRelatedClaim ? "100" : "",
                        cursor: "pointer",
                        marginRight: "6px",
                      }}
                    >
                      {" "}
                      {expandRelatedClaim ? (
                        <p className="minusIcon22">-</p>
                      ) : (
                        <p className="plusIcon22">+</p>
                      )}{" "}
                    </div>
                  }
                  <div className="related-claim-block">
                    {`Related Claims`}
                    <span
                      style={{
                        color: "#888",
                        fontSize: "10px",
                        fontWeight: "400",
                      }}
                    >
                      {" "}
                      {`(${component.relatedClaims.length} items)`}{" "}
                    </span>
                  </div>
                  <div
                    className="info-icon-div"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {
                      <LightTooltip
                        className="mlrToolTip"
                        title="To use Related Claims, first drag and drop the Image to the editor"
                        arrow
                      >
                        <img
                          src={warningBlue}
                          style={{
                            marginLeft: "10px",
                            pointerEvents: "auto",
                          }}
                        />
                      </LightTooltip>
                    }
                  </div>
                </div>
              )}
              {expandRelatedClaim && showCompRelatedClaimsSubpanel && (
                <AccordionClaim
                  relatedClaims={component.relatedClaims}
                  claim={component}
                  customDrag={customDrag}
                  setClaimsOnEditorAsset={setClaimsOnEditorAsset}
                  editor={editor}
                  claimsOnEditorAsset={claimsOnEditorAsset}
                  moduleClaimsData={moduleClaimsData}
                  assignedSymbols={assignedSymbols}
                  setAssignedSymbols={setAssignedSymbols}
                  setPreviewLoading={setPreviewLoading}
                  previewLoading={previewLoading}
                  displayFor="comp"
                  mustUseFlag={component.mustUse}
                  hideUsedOnLHS={usedClaims}
                />
              )}
              {index !== modulesArray.length - 1 && (
                <div className="horizonatlLine"></div>
              )}
              {component.relatedReusableTexts.length > 0 &&
                showCompRelatedReusableSubpanel && (
                <div
                  style={{
                    display: "flex",
                    cursor: "pointer",
                    // pointerEvents: `${parentClaimAdded(claim.claimName) ? 'auto' : 'none'}`,
                    userSelect: "none",
                    padding: "12px 0px 0px",
                  }}
                  onClick={() => {
                    setExpandCompReusableText(!expandCompReusableText);
                  }}
                >
                  {
                    <div
                      className="expand-module"
                      style={{
                        backgroundColor: expandCompReusableText
                          ? "#F0F5F8"
                          : "",
                        color: expandCompReusableText ? "#203662" : "",
                        fontSize: expandCompReusableText ? "24px" : "18px",
                        fontWeight: expandCompReusableText ? "100" : "",
                        cursor: "pointer",
                        marginRight: "6px",
                      }}
                    >
                      {" "}
                      {expandCompReusableText ? (
                        <p className="minusIcon22">-</p>
                      ) : (
                        <p className="plusIcon22">+</p>
                      )}{" "}
                    </div>
                  }
                  <div className="related-claim-block">
                    {`Related Reusable Texts`}
                    <span
                      style={{
                        color: "#888",
                        fontSize: "10px",
                        fontWeight: "400",
                      }}
                    >
                      {" "}
                      {`(${component.relatedReusableTexts.length} items)`}{" "}
                    </span>
                  </div>
                  <div
                    className="info-icon-div"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {
                      <LightTooltip
                        className="mlrToolTip"
                        title="To use Related Reusable Texts, first drag and drop the Image to the editor"
                        arrow
                      >
                        <img
                          src={warningBlue}
                          style={{
                            marginLeft: "10px",
                            pointerEvents: `auto`,
                            width: "11px",
                          }}
                        />
                      </LightTooltip>
                    }
                  </div>
                </div>
              )}
              {expandCompReusableText && showCompRelatedReusableSubpanel && (
                <AccordionClaim
                  relatedClaims={component.relatedReusableTexts}
                  claim={component}
                  customDrag={customDrag}
                  setClaimsOnEditorAsset={setClaimsOnEditorAsset}
                  editor={editor}
                  claimsOnEditorAsset={claimsOnEditorAsset}
                  moduleClaimsData={moduleClaimsData}
                  assignedSymbols={assignedSymbols}
                  setAssignedSymbols={setAssignedSymbols}
                  setPreviewLoading={setPreviewLoading}
                  previewLoading={previewLoading}
                  displayFor="comp"
                  mustUseFlag={component.mustUse}
                  hideUsedOnLHS={usedClaims}
                />
              )}
              {index !== modulesArray.length - 1 && (
                <div className="horizonatlLine"></div>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};
export default AssociatedCard;
